// extracted by mini-css-extract-plugin
module.exports = {"triggerIdWrapper":"EditEMS_triggerIdWrapper__3QhV-"};